const WishlistStyles = {
    baseStyle: {
        motionBox: {
            position: 'absolute',
            width: '14px',
            height: '12px',
            transition: {duration: 0.7, ease: 'easeInOut'}
        }
    }
}

export default WishlistStyles
